/**
 * Pin share icons on scroll
 * @param {string} triggerEl - The element that triggers the animation
 * @param {string} pinnedEl - The element that will be pinned
 */

import gsap, { ScrollTrigger } from 'gsap/all';

const pinShareIconsOnScroll = (triggerEl, pinnedEl) => {
	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.create({
		trigger: triggerEl,
		start: "top 50px",
		end: "bottom 200px",
		pin: pinnedEl,
		pinSpacing: false,
	});
}

export default pinShareIconsOnScroll;